// import { createRouter, createWebHistory } from "vue-router";
// const router = createRouter({
//     routers: [{
//         path: '/',
//         component: () =>
//             import ("../views/index/index.vue"),
//         //引入组件，组件Home.vue所在路径
//         //Home.vue是需要路由的vue组件
//         name: "index",
//     }],
//     scrollBehavior(to, from, savedPosition) {
//         window.scrollTo(0, 0);
//     },
//     history: createWebHistory(),
//     mode: "hash",
// })
import myHome from '../views/index/index.vue'
import userInfo from '../views/userinfo/index.vue'
import myDimension from '../views/dimension/index.vue'
import clothSize from '../views/clothsize/index.vue'
import aiFitter from '../views/aiFitter/index.vue'
import selectParts from '../views/selectParts/index.vue'
import aiEffect from '../views/aiEffect/index.vue'
import poseDetection from '../views/poseDetection/index.vue'
import videoLoad from '../views/loading/index.vue'
const routers = [{
    path: '/',
    component: myHome,
    // component: () =>
    //     import ("../views/index/index.vue"),
    //引入组件，组件Home.vue所在路径
    //Home.vue是需要路由的vue组件
}, {
    path: '/userInfo',
    component: userInfo,
}, {
    path: '/myDimension',
    component: myDimension,
}, {
    path: '/clothSize', //2d效果
    component: clothSize,
}, {
    path: '/aiFitter', //AI量体
    component: aiFitter,
}, {
    path: '/selectParts', //选择衣服部件
    component: selectParts,
}, {
    path: '/aiEffect', //3D页面
    name: 'aiEffect',
    component: aiEffect,
}, {
    path: '/poseDetection',
    component: poseDetection,
}, {
    path: '/videoLoad',
    name: 'videoLoad',
    component: videoLoad,
}]
export default routers